import { render, staticRenderFns } from "./PackageHome.vue?vue&type=template&id=4c67d440&scoped=true&"
import script from "./packageHome.js?vue&type=script&lang=js&"
export * from "./packageHome.js?vue&type=script&lang=js&"
import style0 from "./PackageHome.vue?vue&type=style&index=0&id=4c67d440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c67d440",
  null
  
)

export default component.exports